export const cardShortCode = (key) => {
  const k = (key || "").trim();
  if ((k.length !== 6 && k.length !== 10) || !/^[0-9a-fA-F]+$/.test(k)) return "";
  const a = parseInt(k.slice(2, 4) + k.slice(0, 2), 16);
  const b = parseInt(k.slice(4, 6), 16);
  const s = `${String(b).padStart(3, "0")},${String(a).padStart(5, "0")}`;
  return s === "000,00000" ? "" : s;
};

export const cardColorCss = (color) => {
  const c = Number(color);
  if (!Number.isFinite(c) || c === 16777215) return null;
  return `rgb(${c & 0xff}, ${(c >> 8) & 0xff}, ${(c >> 16) & 0xff})`;
};

export const cardColorHex = (color) => {
  const c = Number(color);
  if (!Number.isFinite(c) || c === 16777215) return "#ffffff";
  return `#${((c >> 16 & 255) << 16 | (c >> 8 & 255) << 8 | (c & 255)).toString(16).padStart(6, "0")}`;
};

export const cardHexToColor = (hex) => {
  const m = /^#?([0-9a-fA-F]{6})$/.exec(hex || "");
  if (!m) return 16777215;
  const v = parseInt(m[1], 16);
  return (v & 0xff) << 16 | (v & 0xff00) | ((v >> 16) & 0xff);
};

export const DOC_STATUS_LABELS = {
  "-1": "Отменена",
  0: "Бронь",
  1: "Подтверждена",
  2: "Заселена",
  3: "Выписана"
};
